var map = {
	"./User.png": 5744,
	"./acai.png": 9275,
	"./avocado_toast.png": 7730,
	"./bacon.png": 4932,
	"./bagel.png": 9216,
	"./bagel_pb.png": 9191,
	"./bagel_sandwich.png": 2250,
	"./blue_drink.png": 2174,
	"./boba_coffee.png": 7440,
	"./boba_fruit.png": 248,
	"./boba_matcha.png": 9100,
	"./boba_specialty.png": 862,
	"./bowl.png": 7485,
	"./bread.png": 7459,
	"./breakfast_bowl.png": 9203,
	"./brownie.png": 3839,
	"./burger.png": 1290,
	"./burrito.png": 3306,
	"./carrot_cake.png": 8021,
	"./chicken.png": 6232,
	"./chicken_bowl.png": 7017,
	"./chips.png": 5756,
	"./chocolate.png": 4223,
	"./chocolate_balls.png": 1256,
	"./chow_mein.png": 9980,
	"./coffee.png": 373,
	"./cookie.png": 8959,
	"./cucumber.png": 4965,
	"./dinner_bowl.png": 7806,
	"./dip.png": 5910,
	"./dumpling.png": 3531,
	"./eggs.png": 7087,
	"./espresso.png": 8625,
	"./falafel.png": 1038,
	"./food_default.png": 4767,
	"./food_plate.png": 8620,
	"./fries.png": 6048,
	"./fruit.png": 8775,
	"./fruit_bowl.png": 5088,
	"./green_drink.png": 1695,
	"./grilled_cheese.png": 9380,
	"./hot_chocolate.png": 9259,
	"./ice_drink.png": 139,
	"./icecream.png": 7804,
	"./iced_coffee.png": 3827,
	"./lemonade.png": 1942,
	"./mac.png": 352,
	"./mango.png": 91,
	"./milkshake.png": 5548,
	"./muffin.png": 2798,
	"./nachos.png": 1773,
	"./noodles.png": 9257,
	"./nuggets.png": 2716,
	"./oatmeal.png": 4608,
	"./onion_rings.png": 7150,
	"./orange.png": 7707,
	"./orange_juice.png": 4990,
	"./pancakes.png": 9601,
	"./pastry.png": 1054,
	"./pb_banana.png": 6611,
	"./peach.png": 9358,
	"./peanut_butter.png": 8253,
	"./pineapple.png": 5931,
	"./pizza.png": 3,
	"./poke.png": 1570,
	"./potatoes.png": 1644,
	"./pudding.png": 1882,
	"./quesadilla.png": 1498,
	"./question_mark.png": 6353,
	"./ramen.png": 468,
	"./salad.png": 6334,
	"./samosa.png": 3973,
	"./sandwich.png": 8502,
	"./sausage.png": 2268,
	"./seaweed.png": 4803,
	"./smoothie.png": 5,
	"./soda.png": 2646,
	"./soup.png": 372,
	"./spring.png": 546,
	"./strawberry.png": 1838,
	"./taco.png": 1990,
	"./taco_party.png": 9255,
	"./taco_special.png": 5418,
	"./tea.png": 3163,
	"./tikka_masala.png": 8833,
	"./tofu.png": 8585,
	"./tofu_bowl.png": 7390,
	"./value.png": 8254,
	"./value_sort.png": 8535,
	"./vanilla.png": 4592,
	"./vegetables.png": 7321,
	"./yogurt.png": 2743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;